<template>
  <div class="container">
    <div class="goPersonal" @click="$router.go(-1)">
      <img src="../../assets/images/icon_left2.png" />
      <span>个人中心</span>
    </div>
    <div class="content">
      <div class="listBox">
        <div class="list" v-for="(item, index) in list" :key="index">
          <a @click="toContentPage(item.Id)">
            <div class="item_img">
              <img class="item_cover" :src="item.Thumbnail" />
              <img
                v-if="item.Type == 1"
                class="playIcon"
                src="@/assets/images/play_comm_icon@2x.png"
              />
            </div>
            <div class="item_content">
              <span class="item_title">{{ item.Title }}</span>
              <div class="item_info">
                <img src="@/assets/images/time@2x.png" />
                <span v-if="item.StartTime">{{ item.StartTime.split("T")[0] }}</span>
              </div>
              <div class="item_nums">
                <div class="nums">
                  <img src="@/assets/images/eye@2x.png" />
                  <span>{{ item.WatchCount }}</span>
                </div>
                <div class="nums">
                  <img src="@/assets/images/likes_ash@2x.png" />
                  <span>{{ item.CollectCount }}</span>
                </div>
              </div>
              <span class="endLabel" v-if="item.status == 4">已结束</span>
            </div>
          </a>
        </div>
      </div>
      <noData style="margin-top: 40%;" v-if="loading && list.length == 0" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import noData from '../../components/noData.vue'
export default {
  name: "MyMeeting",
  data() {
    return {
      form: {
        customerid: "",
        utype: 1,
      },
      activeIndex: 3,
      list: [],
      namelist: [],
      loading: false,
      finished: false,
      error: false,
    };
  },
  components: {
    noData
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.name();
    this.onLoad();
  },
  methods: {
    changeClassify(val) {
      this.loading = false;
      this.activeIndex = val;
      this.onLoad();
      // this.name();
    },
    onLoad() {
      this.$axios.get("/Api/Api/Web/Article/GetUArt").then((res) => {
        this.list = res.Data;
        this.loading = true;
      });
    },
    name() {
      this.form.customerid = this.userInfo.Id;
      let that = this;
      that.list = [];
      that.form.utype = this.activeIndex;
      that.$axios
        .post(
          "/Api/Api/Web/GetArticle_Behavior/GetUserVideo?CustomerID=" +
            that.form.customerid
        )
        .then((res) => {
          that.namelist = res.Data;
        });
    },
    toContentPage(id) {
      if(this.$route.query.source == 'xg') {
        this.$router.push({
          path: 'liveDetails',
          query: {
            id: id,
            source: 'xg'
          }
        });
      } else {
        this.$router.push({
          path: 'liveDetails',
          query: {
            id: id
          }
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  .goPersonal {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #ca001b;
    padding: 10px;
    img {
      display: block;
      width: 10px;
      margin-right: 6px;
    }
  }
  .classify_title {
    display: flex;
    background-color: rgba(216, 216, 216, 0.2);
    .classify_title_item {
      flex: 1;
      text-align: center;
      padding: 12px 0;
      overflow: hidden;
      img {
        width: 25px;
        height: 23px;
        display: block;
        margin: 0 auto;
      }
      span {
        display: block;
        color: #000000;
      }
      .classify_title_text {
        font-size: 14px;
        margin: 6px 0;
      }
      .classify_title_num {
        font-size: 15px;
      }
      .active {
        font-size: 15px;
        color: #ca001b;
        font-weight: bold;
      }
    }
  }
  .listBox {
    display: flex;
    flex-wrap: wrap;
  }
  .content {
    flex: 1;
    height: 0;
    overflow-y: scroll;
    padding: 0 15px 20px;
    box-sizing: border-box;
    .list {
      display: block;
      position: relative;
      width: 100%;
      margin: 0 5px 10px;
      background-color: #ffffff;
      border-radius: 7px;
      border: 1px solid rgba(151, 151, 151, 0.15);
      box-sizing: border-box;
      overflow: hidden;
      .item_img {
        position: relative;
        display: inline-block;
        width: 168px;
        border-radius: 8px;
        height: 2.6rem;
        overflow: hidden;
        vertical-align: middle;
        .item_cover {
          display: block;
          height: 100%;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          border-radius: 8px;
        }
        .playIcon {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 34px;
          height: 34px;
          transform: translate(-17px, -17px);
        }
      }
      .item_content {
        // flex: 1;
        position: relative;
        display: inline-block;
        padding: 6px 11px;
        width: 3.8rem;
        vertical-align: middle;
        .item_title {
          height: 34px;
          line-height: 18px;
          font-size: 13px;
          color: #000000;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-wrap: break-word;
          margin-bottom: 5px;
        }
        .item_info {
          height: 20px;
          line-height: 20px;
          font-size: 12px;
          color: #969696;
          img {
            position: relative;
            top: -1px;
            display: inline-block;
            width: 12px;
            margin-right: 5px;
            vertical-align: middle;
          }
        }
        .item_nums {
          display: flex;
          height: 20px;
          .nums {
            display: flex;
            align-items: center;
            margin-right: 6px;
            img {
              width: 12px;
              margin-right: 2px;
            }
            span {
              font-size: 11px;
              color: #969696;
            }
          }
        }
        .endLabel {
          display: inline-block;
          padding: 0 2px;
          position: absolute;
          right: 6px;
          bottom: 11px;
          font-size: 9px;
          background-color: #E8E8E8;
        }
      }
    }
  }
}
</style>